/*!
  * Furillo tag-filters.js v2.0.0
  * Copyright 2023 Furillo Agency AB (https://www.furillo.se/)  
  */
import { extend, getParent } from './helpers.js';
export default class TagFilter {

    constructor(element, options) {

        const defaults = {
            listWrapper: element.nextElementSibling,
            onFiltered: function () { },
            autoInit: true
        };

        this._element = element;
        this._allowMultiple = element.getAttribute('data-filter-allow-multiple') === 'true';
        this._matchAll = element.getAttribute('data-filter-match-all') === 'true';
        this._serverSide = element.getAttribute('data-filter-server-side') === 'true';
        this._options = extend(defaults, options);
        this.activeFilters = {
            tags: [],
            calendar: [],
            isEmpty: function () { return this.tags.length === 0 && this.calendar.length === 0 },
            clear: function () {
                this.tags = [];                
                this.calendar = [];
            }
        };

        if (this._options.autoInit)
            this.init();
    }

    init() {
        const base = this;

        base._element.querySelectorAll('.dropdown-menu input[type="checkbox"]').forEach(check => {

            check.addEventListener('click', evt => {

                base.toggleCheckbox(evt.target);

                if (base._serverSide) {
                    let href = window.location.href.replace(window.location.search, '');
                    let query = new URLSearchParams(window.location.search);

                    if (query.has('p'))
                        query.delete('p');

                    if (query.has('tags'))
                        query.delete('tags');

                    if (query.has('calendar'))
                        query.delete('calendar');

                    query = base.getCombinedHash(query);

                    // Add query
                    if (query.size > 0) {
                        href += '?' + query.toString().replace('%7C', '|');
                    }

                    // "Redirect"
                    window.location.href = href;
                    return;
                }

                base.filterList();
            });
        });

        // Enable checking boxes by clicking on the "row"
        base._element.querySelectorAll('.dropdown-menu .dropdown-item').forEach(dropdownitem => {
            dropdownitem.addEventListener('click', evt => {
                if (evt.target.nodeName === 'INPUT')
                    return;

                const checkbox = evt.target.parentElement.querySelector('input[type="checkbox"]');
                if (!checkbox)
                    return;

                evt.preventDefault();

                checkbox.checked = !checkbox.checked;

                base.toggleCheckbox(checkbox);
                base.filterList();
            });
        });;

        base._element.querySelector('.tag-filters-active button:not([value])').addEventListener('click', evt => {
            base.activeFilters.clear();

            if (!base._serverSide) {
                window.history.pushState('', document.title, window.location.pathname + '#' + base.getCombinedHash());
            }

            base.filterList();
        });

        window.addEventListener('pageshow', (event) => {
            base.filterList();
        });
    }

    toggleCheckbox(checkbox) {
        const base = this;

        const hash = checkbox.value;
        const filter = checkbox.getAttribute('data-filter');

        if (!checkbox.checked) {
            base.activeFilters[filter] = base.activeFilters[filter].filter(function (item) {
                return item !== hash;
            });
        }
        else {
            if (!base._allowMultiple)
                base.activeFilters[filter] = [];

            base.activeFilters[filter].push(hash);
        }

        if (!base._serverSide) {
            window.history.pushState('', document.title, window.location.pathname + '#' + base.getCombinedHash());
        }
    }

    getCombinedHash(query) {
        const base = this;

        if (base.activeFilters.isEmpty())
            return '';

        if (!query) {
            query = new URLSearchParams();
        }

        if (base.activeFilters.tags.length > 0) {
            if (base.activeFilters.tags.length === 1)
                query.set('tags', base.activeFilters.tags[0]);
            else
                query.set('tags', base.activeFilters.tags.join('|'));
        }

        if (base.activeFilters.calendar.length > 0) {
            if (base.activeFilters.calendar.length === 1)
                query.set('calendar', base.activeFilters.calendar[0]);
            else
                query.set('calendar', base.activeFilters.calendar.join('|'));
        }

        return query.toString().replace('%7C', '|');
    }

    filterList() {
        const base = this;

        // If no tags active, check in the url
        if (base.activeFilters.isEmpty()) {

            let query = null;
            if (!base._serverSide) {
                var hash = decodeURIComponent(window.location.hash);
                if (hash && hash.length > 0)
                    query = new URLSearchParams(hash.replace('#', ''));
            } else {
                query = new URLSearchParams(window.location.search);
            }

            if (query && query.size > 0) {

                if (query.has('tags')) {
                    const items = query.get('tags').split('|');
                    for (var i = 0; i < items.length; i++) {
                        base.activeFilters.tags.push(items[i]);
                    }
                }

                if (query.has('calendar')) {
                    const items = query.get('calendar').split('|');
                    for (var i = 0; i < items.length; i++) {
                        base.activeFilters.calendar.push(items[i]);
                    }
                }

            }
        }

        base._element.querySelector('.tag-filters-empty').classList.add('d-none');

        // Manage filter buttons
        const activeTagFiltersContainer = base._element.querySelector('.tag-filters-active');
        const clearAllButton = activeTagFiltersContainer.querySelector('button:not([value])');

        activeTagFiltersContainer.classList.add('d-none');

        activeTagFiltersContainer.querySelectorAll('button[value]').forEach(button => {
            button.remove();
        });

        base._element.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
            checkbox.checked = false;

            const filter = checkbox.getAttribute('data-filter');
            for (var i = 0; i < base.activeFilters[filter].length; i++) {
                if (checkbox.value === base.activeFilters[filter][i]) {
                    checkbox.checked = true;

                    const title = checkbox.nextElementSibling.textContent.trim();

                    let button = document.createElement('button');
                    button.type = 'button';
                    button.value = checkbox.value;
                    button.setAttribute('data-filter', filter);
                    button.title = "Ta bort filter '" + title + "'.";
                    button.textContent = title;
                    button.classList.add('btn', 'btn-sm', 'btn-outline-dark', 'me-1', 'mb-1');

                    button.addEventListener('click', evt => {
                        const btnValue = evt.target.value;
                        const btnFilter = evt.target.getAttribute('data-filter');
                        const linkedCheckbox = base._element.querySelector('input[type="checkbox"][value="' + btnValue + '"][data-filter="' + btnFilter + '"]');
                        linkedCheckbox.checked = false;

                        base.toggleCheckbox(linkedCheckbox);
                        base.filterList();
                    });

                    activeTagFiltersContainer.insertBefore(button, clearAllButton);
                }
            }
        });

        if (activeTagFiltersContainer.querySelectorAll('button[value]').length > 0) {
            activeTagFiltersContainer.classList.remove('d-none');
        }

        // Clear filters
        if (base.activeFilters.isEmpty()) {
            base._options.listWrapper.querySelectorAll('*[data-tags],*[data-calendar]').forEach(element => {
                let item = getParent(element, '.umb-block-grid__layout-item');
                if (!item)
                    item = element;

                item.classList.remove('d-none');
            });
            base._options.onFiltered();
            return;
        }

        if (base._serverSide)
            return;

        const itemVisible = function (element, filter) {

            const activeFilter = base.activeFilters[filter];
            if (activeFilter.length === 0) {
                return true;
            }

            let visible = false;
            for (var i = 0; i < activeFilter.length; i++) {
                let tag = activeFilter[i].replace('#', '');

                if (element.getAttribute('data-' + filter).indexOf(tag) > -1) {
                    visible = true;

                    if (!base._matchAll)
                        break;
                } else if (base._matchAll) {
                    visible = false;
                    break;
                }
            }
            return visible;
        };

        // Filter
        base._options.listWrapper.querySelectorAll('*[data-tags],*[data-calendar]').forEach(element => {

            let item = getParent(element, '.umb-block-grid__layout-item');
            if (!item)
                item = element;

            item.classList.add('d-none');

            if (itemVisible(element, 'tags') && itemVisible(element, 'calendar')) {
                item.classList.remove('d-none');
            }
        });

        if (base._options.listWrapper.querySelectorAll('.umb-block-grid__layout-item:not(.d-none)').length === 0) {
            base._element.querySelector('.tag-filters-empty').classList.remove('d-none');
        }

        base._options.onFiltered();
    }
};